import React from 'react';
import styled from 'styled-components';
import {
  secondaryFont, wLight, primaryHeadingColor, wMedium, primaryFont, maxWidth, retina,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
 .general-detail-persona{
    padding:0 30px;
    margin-bottom:90px;
    .sub-heading{
      margin-top:24px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-top: 20px;
        font-size: 18px;
      }
    }
    .title-persona{
      font-size:26px;
      font-family:${secondaryFont};
      font-weight:${wLight};
      color:${primaryHeadingColor};
      margin-bottom:34px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 22px;
        margin-bottom: 14px;
      }
    }
    ul{
      margin:0 0 0px 18px;
      padding:0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-bottom: 20px;
      }
    }
    p {
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-bottom: 20px;
      }
    }
    p, li{
      font-size:18px;
      color:#67696A;
      font-weight:${wMedium};
      font-family:${primaryFont};
      margin:0;
      padding:0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 14px;
      }
    }
  }
  .job-roles{
    text-align:left;
    margin-left:-4px;
    span {
      @media all and (max-width: ${maxWidth}) , ${retina} {
        padding: 3px 25px;
        font-size: 13px;
      }
    }
  }
`;

type Props = {
  children?: object,
} & typeof defaultProps;

const defaultProps = {
  children: <div />,
};

const PersonalityGeneralDetails = function PersonalityGeneralDetails(props: Props) {
  const { children } = props;
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
};

PersonalityGeneralDetails.defaultProps = defaultProps;
export default PersonalityGeneralDetails;
